import { useEffect } from "react"
import HCRender from "aldoo-ra/HelpCenter/hc-render"
import Typography from "aldoo-ra/Typography"
import TextBundle from "aldoo-ra/CMS/text-bundle"

const HelpCenterBrowser = ({
  rootCategoriesData = null,
  onArticleSelect,
  onCategorySelect,
  currentPath = {},
  expandedCategories = {},
}) => {
  const texts = TextBundle({ id: "help-center" })
  const BrowserCategory = HCRender.getFragment("BrowserCategory")

  useEffect(() => {
    const isPathEmpty =
      !currentPath.type &&
      !currentPath.slug &&
      !currentPath.categoryPath &&
      !currentPath.exactPath &&
      !currentPath.directParentPath

    if (
      isPathEmpty &&
      expandedCategories &&
      Object.keys(expandedCategories).length > 0
    ) {
      onCategorySelect && onCategorySelect(null, true)
    }
  }, [currentPath, expandedCategories, onCategorySelect])

  if (!rootCategoriesData) {
    return (
      <Typography variant="body1">
        {texts?.no_categories_found || "No help center categories found"}
      </Typography>
    )
  }

  const getCategoriesToRender = () => {
    let categories = []

    if (Array.isArray(rootCategoriesData)) {
      categories = rootCategoriesData
    } else if (
      rootCategoriesData.content &&
      Array.isArray(rootCategoriesData.content.categories)
    ) {
      categories = rootCategoriesData.content.categories
    } else if (
      rootCategoriesData.toc &&
      rootCategoriesData.toc.content &&
      Array.isArray(rootCategoriesData.toc.content.categories)
    ) {
      categories = rootCategoriesData.toc.content.categories
    } else {
      return []
    }

    return categories.filter((category) => {
      const status = category.status || category.content?.status
      return !status || status === "published"
    })
  }

  const categoriesToRender = getCategoriesToRender()

  if (categoriesToRender.length === 0) {
    return (
      <Typography variant="error">
        {texts?.invalid_cat_structure || "No categories found"}
      </Typography>
    )
  }

  if (!BrowserCategory) return null

  return (
    <div>
      {categoriesToRender.map((category) => (
        <BrowserCategory
          key={category._id}
          category={category}
          onArticleSelect={onArticleSelect}
          onCategorySelect={onCategorySelect}
          expandedCategories={expandedCategories}
          currentPath={currentPath}
          fullPath=""
          preloadedData={true}
        />
      ))}
    </div>
  )
}

export default HelpCenterBrowser
